import { axiosClient } from "@/shared/api/axios-client";
import type { BandejaAutorizacionPage } from "@/lib/types";

/**
 * Listado PAGINADO de solicitudes pendientes para el rol actual. El backend ya
 * filtra por nivel/rol/organización del usuario, y además aplica los filtros de
 * columna (server-side) y el paginado (page/pageSize) que se pasen como query
 * params. Devuelve el envelope {items, total, page, pageSize}.
 */
export async function listarBandejaAutorizacion(
  params: Record<string, string | number> = {},
): Promise<BandejaAutorizacionPage> {
  const { data } = await axiosClient.get<BandejaAutorizacionPage>(
    "/api/autorizacion/bandeja",
    { params },
  );
  return data;
}
